import React from 'react';
import './DeleteBanner.css';
import CloseIcon from '@mui/icons-material/Close';
import ClearIcon from '@mui/icons-material/Clear';

const DeleteBanner = ({ isOpen, onClose, onConfirm, bannerTitle = 'this banner' }) => {
  if (!isOpen) return null;

  return (
    <div className="delete-banner-overlay">
      <div className="delete-banner-modal">
        <div className="delete-banner-header">
          <h2>Delete Banner</h2>
          <button className="close-button" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>

        <div className="delete-banner-content">
          <div className="delete-banner-icon">
            <ClearIcon sx={{ color: '#DC2626', fontSize: 32 }} />
          </div>

          <p className="delete-banner-message">
            Are you sure you want to delete "
            <span className="banner-title-text">{bannerTitle}</span>"?
            <br />
            This action cannot be undone.
          </p>
        </div>

        <div className="delete-banner-actions">
          <button className="cancel-button" onClick={onClose}>
            Cancel
          </button>
          <button className="delete-button" onClick={onConfirm}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteBanner;
